/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: ButtonFavorite.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  06.07.22 5:42 pm.
 * Last modified: 06.07.22 5:42 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { addBuildHash } from '../api/helpers';
import { useIsFavoriteGame } from '../contexts/FavoriteContext';
import { useLobbyHost } from '../contexts/SettingsContext';
import store from '../eventStore';

const ButtonFavorite = ({ gameKey }: IButtonFavoriteProps) => {
    const selected = useIsFavoriteGame(gameKey);
    const host = useLobbyHost();
    return (
        <div className="egt_game_btn_favorite" onClick={() => store.ON_CLICK_FAVORITE.next(gameKey)}>
            <img
                className="icon"
                src={addBuildHash(`${host}/assets/portal/ui/${selected ? 'favoritesOn' : 'favoritesOff'}.svg`)}
                alt=""
            />
        </div>
    );
};

export interface IButtonFavoriteProps {
    gameKey: string;
}

export default ButtonFavorite;
